import React from 'react'
import { connect } from 'react-redux'

import { COLOR, NATIVE_BASE_COLORS } from '../../../../../../../themes'
import { ORDER_MANAGER } from '../../../../../../../helpers'

import { OrderModalTabStyle } from './styles'

function OrderModalTab(props) {
  const {
    selectedTab,
    orderModalTab,
    selectedOrderTab,
    setSelectedOrderTab,
    language,
    colorTheme,
  } = props

  const borderBottomLineStyle = (value) => {
    return ({
      backgroundColor: (selectedOrderTab === value) && colorTheme 
        ? colorTheme.MAIN
        : COLOR.TRANSPARENCY,
      width: '80%',
      height: '3px',
      position: 'absolute',
      transform: 'translateY(7px)',
      bottom: '0',
      borderRadius: '8px 8px 0 0',
      zIndex: '3',
    })
  }

  const tabStyle = (value) => {
    return ({
      color: selectedOrderTab !== value && NATIVE_BASE_COLORS.TEXT[400],
    })
  }

  return (
    <OrderModalTabStyle>
      {(selectedTab === ORDER_MANAGER.VALUE.CATERING || selectedTab === ORDER_MANAGER.VALUE.EQUIPMENT) &&
        orderModalTab[selectedTab].map(({ value, text }) => {
          return (
            <div
              key={value}
              className='order-modal__top'
            >
              <label
                className='order-modal__box__tab'
                htmlFor={value}
                style={tabStyle(value)}
              >
                {text[language]}
              </label>
              <input
                type='radio'
                id={value}
                name='orderModalTab'
                value={value}
                onChange={(event) => setSelectedOrderTab(Number(event.target.value))}
                checked={value === selectedOrderTab}
              />
              <div style={borderBottomLineStyle(value)} />
            </div>
          )
        })
      }
    </OrderModalTabStyle>
  )
}

const mapStateToProps = ({ accountReducer }) => {
  return {
    colorTheme: accountReducer.user.colorThemePalette,
    language: accountReducer.language
  }
}

export default connect(mapStateToProps  ,null)(OrderModalTab)
